import React from "react";
import { Box, Flex } from "rebass";
import Heart from "../icons/Heart";
import { getLocalizedText } from "../utils/getLocalizedText";
import { BsColumnsGap } from "react-icons/bs";
import { getLocalizedString } from "../utils/getLocalizedString";
import TabButton from "../components/common/TabButton";
const BarWishlist = () => {
  return (
    <Flex
      sx={{
        width: "100%",
        minHeight: "50px",
        bg: "#f4f4f4",
        fontSize: "16px",
        fontWeight: "bold",
        borderBottom: "1px solid #000000",
        paddingLeft: "15px",
        paddingRight: "15px",
      }}
      alignItems={"center"}
      justifyContent={"space-between"}
    >
      <Flex alignItems={"center"}>
        <Heart
          stylePath={{
            fill: "#A2A2A2",
            stroke: "#A2A2A2",
          }}
        />
        <span
          style={{
            paddingLeft: "10px",
            color: "#A2A2A2",
            fontWeight: "400",
          }}
        >
          {getLocalizedText("WISHLIST")}
        </span>
      </Flex>

      <Flex alignItems={"center"}>
        <TabButton
          activeIcon={<BsColumnsGap style={{ width: 16 }} />}
          tooltip={getLocalizedString("CATALOGUE")}
          sx={{ marginRight: "10px" }}
        />
      </Flex>
    </Flex>
  );
};

export default BarWishlist;
